import './accordion.scss';

const toggleAccordionItem = ( trigger ) => {
	const targetId = trigger.getAttribute( 'aria-controls' );
	const content   = targetId ? document.getElementById( targetId ) : null;
	if ( ! content ) {
		return;
	}

	const wasOpen = trigger.getAttribute( 'aria-expanded' ) === 'true';
	const item    = trigger.closest( '.b-accordion__item' );

	content.hidden = wasOpen;
	item?.classList.toggle( 'is-open', ! wasOpen );

	// A title button and a readmore link can both control the same content; keep them in sync.
	document.querySelectorAll( `[aria-controls="${ targetId }"]` ).forEach( ( el ) => {
		el.setAttribute( 'aria-expanded', wasOpen ? 'false' : 'true' );
	} );

	const readmoreText = item?.querySelector( '.js-accordionReadmoreText' );
	if ( readmoreText ) {
		readmoreText.textContent = wasOpen
			? readmoreText.dataset.labelClosed
			: readmoreText.dataset.labelOpen;
	}
};

document.querySelectorAll( '.js-accordionTrigger' ).forEach( ( trigger ) => {
	trigger.addEventListener( 'click', () => toggleAccordionItem( trigger ) );
} );
